import { useEffect, useState } from "react";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { Modal } from "react-bootstrap";
import Lang from "../../userPreferences/staticWords";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Button from "../sharedComponents/buttons/button";
import MembersList from "../../algorithms/listsAlogrithms";
import DateInput from "../sharedComponents/datesInputs/date";
import {
  addAssignmentAPI,
  updateAssignmentAPI,
} from "../../API/store/actions/PresidentialAssignmenty";
import { useDispatch, useSelector } from "react-redux";
import DropDownList from "../sharedComponents/dropdown/dropdown";

const AssignmentForm = (props) => {
  const { show, setShow, isEdit, onSuccess, members } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);
  const selectedAssignment = useSelector(
    (state) => state.assignments.selectedAssignment,
  );

  const [formData, setFormData] = useState({
    subject: "",
    assignmentNumber: "",
    adminTaskMember: undefined,
    startDate: "",
    endDate: "",
    members: [],
    attachments: [],
  });
  const taskMembers = members.filter(
    (member) => member.memberId !== Number(formData.adminTaskMember),
  );
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleFilesChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      attachments: Array.from(e.target.files),
    }));
  };
  useEffect(() => {
    if (!show) return;

    if (isEdit && selectedAssignment) {
      setFormData({
        id: selectedAssignment.id,
        subject: selectedAssignment.titleA || "",
        adminTaskMember: selectedAssignment?.adminmember?.memberId || undefined,
        startDate: selectedAssignment.startDate
          ? new Date(selectedAssignment.startDate)
          : "",
        endDate: selectedAssignment.endDate
          ? new Date(selectedAssignment.endDate)
          : "",
        members: selectedAssignment.member?.map((item) => item.memberId) || [],
        attachments: [],
      });
    }
  }, [show, isEdit, selectedAssignment]);
  useEffect(() => {
    if (!show) {
      setFormData({
        subject: "",
        assignmentNumber: "",
        adminTaskMember: undefined,
        startDate: "",
        endDate: "",
        members: [],
        attachments: [],
      });
      setErrors({});
    }
  }, [show]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = {};

    if (!formData.subject.trim()) {
      validationErrors.subject = "موضوع التكليف مطلوب";
    }

    if (!formData.startDate) {
      validationErrors.startDate = "تاريخ البدء مطلوب";
    }

    if (!formData.endDate) {
      validationErrors.endDate = "تاريخ الانتهاء مطلوب";
    }
    if (!formData.adminTaskMember) {
      validationErrors.adminMember = "يجب اختيار جهة رئيسية ";
    }

    if (formData.members.length === 0) {
      validationErrors.members = "يجب اختيار جهة مشاركة واحدة على الأقل";
    }

    // if (formData.attachments.length === 0) {
    //   validationErrors.attachments = "المرفقات مطلوبة";
    // }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    setIsSubmitting(true);

    try {
      const data = new FormData();

      data.append("TitleA", formData.subject);
      data.append("TitleE", formData.subject); // or another English title
      data.append("StartDate", new Date(formData.startDate).toISOString());
      data.append("EndDate", new Date(formData.endDate).toISOString());

      data.append("AdminTaskMembers", formData.adminTaskMember);

      formData.members.forEach((id) => {
        data.append("TaskMembers", id);
      });

      formData.attachments.forEach((file) => {
        data.append("files", file);
      });

      if (isEdit) {
        data.append("Id", formData.id);
      }
      const action = isEdit
        ? await updateAssignmentAPI(data, userToken)
        : await addAssignmentAPI(data, userToken);
      dispatch(action);
      onSuccess?.();
      setShow(false);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 25,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1 mt-1"
            >
              <img
                src={"/assets/policy-green.svg"}
                width={25}
                height={25}
                alt=""
              />
            </div>{" "}
            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "rgb(12, 87, 76)",
                }}
              >
                {!isEdit
                  ? Lang.addPresidentialAssignment
                  : Lang.editPresidentialAssignment}
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"rgb(12, 87, 76)"}
            onclick={() => setShow(false)}
          />
        </div>
      </Modal.Header>
      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Assignment Subject */}
            <div className="col-12 col-md-12 mb-3">
              <label className="form-label">عنوان التكليف</label>
              <input
                type="text"
                name="subject"
                className="form-control"
                placeholder="اكتب عنوان التكليف"
                value={formData.subject}
                onChange={(e) => {
                  handleChange(e);

                  if (errors.subject) {
                    setErrors((prev) => ({ ...prev, subject: "" }));
                  }
                }}
              />{" "}
              {errors.subject && (
                <div className="invalid-feedback d-block">{errors.subject}</div>
              )}
            </div>

            {/* Start Date */}
            <div className="col-12 col-md-6 mb-3">
              <label className="form-label">تاريخ البدء</label>
              <DateInput
                inputStyle={"upperZIndex"}
                placeholder={Lang.form}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                iconPrefix="far"
                iconName="calendar"
                value={formData.startDate}
                onChange={(date) => {
                  setFormData((prev) => ({
                    ...prev,
                    startDate: date,
                  }));

                  if (errors.startDate) {
                    setErrors((prev) => ({ ...prev, startDate: "" }));
                  }
                }}
                iconSize={22}
              />
              {errors.startDate && (
                <div className="text-danger mt-1">{errors.startDate}</div>
              )}
            </div>
            {/* End Date */}
            <div className="col-12 col-md-6 mb-3">
              <label className="form-label">تاريخ الانتهاء</label>

              <DateInput
                inputStyle={"upperZIndex"}
                placeholder={Lang.form}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                iconPrefix="far"
                iconName="calendar"
                value={formData.endDate}
                onChange={(date) => {
                  setFormData((prev) => ({
                    ...prev,
                    endDate: date,
                  }));

                  if (errors.endDate) {
                    setErrors((prev) => ({ ...prev, endDate: "" }));
                  }
                }}
                iconSize={22}
              />
              {errors.endDate && (
                <div className="text-danger mt-1">{errors.endDate}</div>
              )}
            </div>
            {(!isEdit || selectedAssignment) && (
              <DropDownList
                placeholder={Lang.MainAdminMembers}
                border={true}
                containerStyle="col-12 align-items-center mx-auto"
                dataSource={members.map((item) => ({
                  id: item.memberId,
                  name: item.memberName,
                }))}
                value={formData.adminTaskMember ?? undefined}
                change={(e) => {
                  const adminId = Number(e.value);

                  setFormData((prev) => ({
                    ...prev,
                    adminTaskMember: adminId,
                    members: prev.members.filter((id) => id !== adminId),
                  }));
                }}
              />
            )}
            {errors.adminMember && (
              <div className="text-danger mt-2">{errors.adminMember}</div>
            )}
            {/* Participating Entities */}
            <div className="col-12 my-3">
              {" "}
              <label className="form-label">الجهات المشاركة</label>
              <MembersList
                containerStyle="d-flex flex-column mb-4 col-12"
                aboveTitleStyle={`d-flex px-3 col-12 mb-3 ${styleStart("m", 2)}`}
                cardStyle={`d-flex flex-column col-12 py-2 mx-1 ${customStyle("TitleCard")}`}
                cardTitle={Lang.adminMembers}
                list={taskMembers}
                id="A"
                checked
                values={formData.members}
                onChange={(e) => {
                  const memberId = Number(e.target.value);

                  setFormData((prev) => ({
                    ...prev,
                    members: e.target.checked
                      ? [...prev.members, memberId]
                      : prev.members.filter((id) => id !== memberId),
                  }));

                  if (errors.members) {
                    setErrors((prev) => ({ ...prev, members: "" }));
                  }
                }}
              />
              {errors.members && (
                <div className="text-danger mt-2">{errors.members}</div>
              )}
            </div>
            {/* Attachments */}
            <div className="col-12 mb-4">
              <label className="form-label">المرفقات</label>
              <input
                type="file"
                className="form-control"
                multiple
                onChange={handleFilesChange}
              />{" "}
            </div>
            <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
              <Button
                type={"submit"}
                disable={isSubmitting}
                buttonStyleType={"solid"}
                content={isSubmitting ? Lang.isSaving : Lang.save}
                containerStyle="col-2 mx-3"
              />
              <Button
                type={"button"}
                onClick={() => setShow(false)}
                content={Lang.cancel}
                containerStyle="col-2 mx-3"
              />
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AssignmentForm;
